import * as Yup from 'yup';

const authValidation = (t: (key: string) => string) => ({
  forgotPassword: Yup.object().shape({
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, t('validation.phoneInvalid'))
      .required(t('validation.phoneRequired')),
  }),
  resetPassword: Yup.object().shape({
    password: Yup.string().required(t('validation.passwordRequired')).min(6, t('validation.passwordMinLength')),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), undefined], t('validation.passwordMismatch'))
      .required(t('validation.confirmPasswordRequired'))
      .min(6, t('validation.passwordMinLength')),
  }),
  changePassword: Yup.object().shape({
    new_password: Yup.string().required(t('header.newPasswordRequired')),
    new_password_confirmation: Yup.string()
      .required(t('header.newPasswordRequired'))
      .oneOf([Yup.ref('new_password')], t('header.newPasswordConfirm')),
  }),
});

export default authValidation;
